// 每天获取最大抽奖次数
export const MAX_LOTTERY_NUM = 5;

export const PAGE_NAME = 'invite_lottery';

export const TABS = [
  { key: 'task', label: '天天邀好友得次数' },
  { key: 'reward', label: '我的奖品' },
];

// 添加任务和奖励配置
export const TASK_LIST = [
  {
    key: 'share',
    title: '分享活动给好友',
    desc: '每天微信成功分享活动，您可得1次抽奖机会。超简单，快来试试！',
    maxNum: 1,
    buttonText: '去完成',
    flag: '',
  },
  {
    key: 'register',
    title: '邀请好友注册网心云',
    desc: '每天邀请1人注册您可得1次抽奖机会+7天10%加成卡',
    maxNum: 1,
    buttonText: '去完成',
    flag: '',
  },
  {
    key: 'bind',
    title: '邀好友绑定手机宝/电脑宝',
    desc: '每天邀好友首次绑定手机宝/电脑宝，得1次抽奖机会+100云豆',
    maxNum: 3,
    buttonText: '去提醒',
    flag: '最低可抽100云豆！',
  },
];

// 抽奖组件相关配置
export const WHEEL_BUTTON = [
  {
    radius: '45%',
    imgs: [
      {
        src: require('@/assets/images/acts/invite-lottery/lottery-pointer-disable.png'),
        width: '1.62rem',
        top: '-0.98rem',
      },
    ],
  },
];

export const WHEEL_BLOCK = [
  {
    imgs: [
      {
        src: require('@/assets/images/acts/invite-lottery/wheel-bg.png'),
        width: '4.8rem',
        height: '4.8rem',
        rotate: true,
      },
    ],
    // padding: '0.7rem',
  },
];

export const LOTTERY_PRIZE_ICON = {
  src: require('@/assets/images/acts/invite-lottery/wheel-prize.png'),
  width: '0.36rem',
  height: '0.26rem',
  top: '55%',
};

export const LOTTERY_PRIZE_LIST = [
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '5万云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 12,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '1万云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 13,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '2000云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 14,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '1000云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 15,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '500云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 16,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '100云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 17,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '10云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 18,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '2云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 19,
  },
  {
    imgs: [LOTTERY_PRIZE_ICON],
    fonts: [
      {
        text: '10万云豆',
        top: '16%',
        fontSize: '0.24rem',
        fontColor: '#F48140',
        lineHeight: '0.34rem',
        fontWeight: 500,
      },
    ],
    prizeNo: 11,
  },
];

// 抽奖状态，0-未开始，1-正在进行，2-抽奖失败
// 抽奖未开始
export const LOTTERY_NOT_START_STATUS = 0;
// 正在抽奖
export const IN_LOTTERY_STATUS = 1;
// 抽奖失败
export const LOTTERY_FAILED_STATUS = 2;
